import { __awaiter } from "tslib";
import { useSelector } from 'react-redux';
import { getOrder } from '../../../../Checkout/store/order/selectors';
import { useToggleable } from '../../../../hooks';
import { useCallback, useState } from 'react';
import { useIsCheckinAvailable } from '../../../../Checkout/hooks';
import { TravellerFieldEnum, useCheckinCreateOrderMutation, useCheckinRulesQuery, useGetCheckinOrderQuery, useResetOrderPaymentBlockMutation } from '@websky/graphql';
import { useConfig } from '../../../../context';
import { getCheckInUrl } from '../../../../utils';
import { useCheckinError } from '../../../../Modules/Checkin/hooks/useCheckinError';
export const useStartCheckIn = () => {
    var _a, _b;
    const order = useSelector(getOrder);
    const { isOpen: isRulesModalOpen, open: openRulesModal, close: closeRulesModal } = useToggleable(false);
    const [checkinOrderId, setCheckinOrderId] = useState();
    const [checkinCreationInProgress, setCheckinCreationInProgress] = useState(false);
    const isCheckinAvailable = useIsCheckinAvailable(order);
    const { handleError: handleCheckinError } = useCheckinError();
    const [createCheckin] = useCheckinCreateOrderMutation();
    const [resetOrderPaymentBlock] = useResetOrderPaymentBlockMutation();
    const { refetch: getCheckinOrder } = useGetCheckinOrderQuery({ skip: true, fetchPolicy: 'no-cache' });
    const { Engine: { checkInEnabled, checkInURL }, global: { companyInfo: { iataCode }, reserveEngines } } = useConfig();
    const rulesData = useCheckinRulesQuery({
        variables: {
            id: order.id
        },
        skip: !checkInEnabled || !checkInURL || !isCheckinAvailable || iataCode === 'N4'
    });
    const goToCheckin = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e;
        const traveller = order.travellers[0];
        const ticket = ((_d = (_c = traveller === null || traveller === void 0 ? void 0 : traveller.tickets) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.number) || order.locator;
        const lastName = (_e = traveller.values.find(value => value.type === TravellerFieldEnum.LastName)) === null || _e === void 0 ? void 0 : _e.value;
        const orderId = order.id;
        if ((reserveEngines === null || reserveEngines === void 0 ? void 0 : reserveEngines.redirectToWebsky1) && (reserveEngines === null || reserveEngines === void 0 ? void 0 : reserveEngines.checkin)) {
            window.open(getCheckInUrl(checkInURL, orderId, ticket, lastName, reserveEngines), '_blank');
        }
        else {
            setCheckinCreationInProgress(true);
            setCheckinOrderId('');
            let checkinOrderCreated = false;
            let checkinErrorHandled = false;
            try {
                const { data, errors } = yield createCheckin({
                    variables: {
                        params: { aviaOrderId: order.id }
                    }
                });
                if ((errors === null || errors === void 0 ? void 0 : errors.length) && handleCheckinError(errors)) {
                    checkinErrorHandled = true;
                }
                else if (data === null || data === void 0 ? void 0 : data.CheckinCreateOrder) {
                    const orderId = data.CheckinCreateOrder.id;
                    let result = data.CheckinCreateOrder;
                    if (data.CheckinCreateOrder.isBlockedForPayment) {
                        yield resetOrderPaymentBlock({ variables: { id: orderId } });
                        const { data, errors } = yield getCheckinOrder({ id: orderId });
                        if (data.CheckinOrder && !errors) {
                            result = data.CheckinOrder;
                        }
                    }
                    setCheckinOrderId(result.id);
                    checkinOrderCreated = true;
                    if (checkInEnabled && checkInURL) {
                        if (iataCode === 'N4') {
                            window.open(getCheckInUrl(checkInURL, result.id), '_blank');
                        }
                        else {
                            openRulesModal();
                        }
                    }
                }
            }
            catch (e) {
                if (handleCheckinError(e)) {
                    checkinErrorHandled = true;
                }
                else {
                    console.warn('Could not create check-in order. Proceed with passenger credentials.');
                }
            }
            setCheckinCreationInProgress(false);
            if (!checkinOrderCreated && !checkinErrorHandled) {
                window.open(getCheckInUrl(checkInURL, orderId, ticket, lastName), '_blank');
            }
        }
    });
    const acceptRules = useCallback(() => {
        if (checkinOrderId) {
            window.open(getCheckInUrl(checkInURL, checkinOrderId), '_blank');
        }
        closeRulesModal();
    }, [checkinOrderId, checkInURL, closeRulesModal]);
    return {
        loading: checkinCreationInProgress,
        isCheckinAvailable,
        isRulesModalOpen,
        closeRulesModal,
        checkinRules: (_b = (_a = rulesData === null || rulesData === void 0 ? void 0 : rulesData.data) === null || _a === void 0 ? void 0 : _a.CheckinRules) !== null && _b !== void 0 ? _b : null,
        goToCheckin,
        acceptRules
    };
};
